import { render } from "./AssistantConfirm.vue?vue&type=template&id=2a59d422&scoped=true"
import script from "./AssistantConfirm.vue?vue&type=script&lang=js"
export * from "./AssistantConfirm.vue?vue&type=script&lang=js"

import "./AssistantConfirm.vue?vue&type=style&index=0&id=2a59d422&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a59d422"]])

export default __exports__